/**
 * @file LoginView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Grid, Snackbar, Typography } from "@mui/material";
import React from "react";
import "./../Login.css"
import LeftLoginView from "./LeftLoginView";
import { LoginViewModel } from "../viewmodels/LoginViewModel";
import { LoginFormController } from "../controllers/LoginFormController";
import { AppAlert } from "../../utils/AppAlert";
import { ResetPasswordViewController } from "../controllers/ResetPasswordViewController";
import { AppVersion } from "../../utils/AppConstant";
import { Img } from "../../common/customviews/AppImg";

/**
 * A type of Component state
 */
type CompState = { isOnline: boolean, toggleError: boolean, state: State };

/**
 * An interface definition for Component Props
 */
interface Props {
    viewModel: LoginViewModel;
}

/**
 * A type of Component state
 */
enum State {
    Login = 1,
    ResetPassword = 2
}

/**
 * A class definition for LoginView
 */
export class LoginView extends React.Component<Props, CompState> {

    constructor(props: Props) {
        super(props)
        this.state = {
            isOnline: navigator.onLine,
            toggleError: false,
            state : State.Login
        };
    }

    /**
     * Handles forgot password click
     */
    private onForgotPasswordClicked = ()=>{
        this.setState({
            state: State.ResetPassword
        });
    }

    /**
     * Handles finish event of forgot password
     */
    private onForgotPasswordFinished = ()=> {
        this.setState({
            state: State.Login
        });
    }

    /**
     * Hides error
     */
    hideError = () => {
        this.setState({ toggleError: false });
    }

    render() {

        return <React.Fragment>
            <Grid container className="LoginGrid" flexDirection={"row"} >
                <Grid container item sm={12} md={6} className="LeftLoginGrid">
                    <LeftLoginView />
                </Grid>
                <Grid container item sm={12} md={6} className="RightLoginGrid" alignItems="center">
                    <div style={{height:"100%"}}>
                        <div style={{height:"85%", alignItems: "center", display: "flex"}}>
                            {this.state.state === State.Login && ( <div className="animation"> <LoginFormController onForgotPasswordClicked={this.onForgotPasswordClicked}/> </div>)}
                            {this.state.state === State.ResetPassword && ( <div className="animation"> <ResetPasswordViewController onForgotPasswordFinished={this.onForgotPasswordFinished}/></div> )}
                        </div>
                        <div style={{bottom: "0", textAlign:"center"}}>
                            <Img alt="complex" src="/../boston.svg"  />
                            <Typography className="VersionText">{AppVersion}</Typography>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <Snackbar open={this.state.toggleError} autoHideDuration={6000} onClose={this.hideError}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} >
                <AppAlert onClose={this.hideError} severity={this.state.isOnline ? "success" : "error"} sx={{ width: "150%" }}>
                    {this.state.isOnline ? `You"re online` : `You"re offline`}
                </AppAlert>
            </Snackbar>
        </React.Fragment>
    }
}